import React, { useState } from 'react';
import Modal from '@/Components/Modal/Modal';
import IconClose from '@/svgs/delete.svg?react';
import ReactPlayer from 'react-player';

interface Props {
  title: string;
  videoUrl: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function VideoPlayerModal({
  title,
  videoUrl,
  isOpen,
  onClose,
}: Props) {
  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const [open, setOpen] = useState(isOpen);

  return (
    <Modal isOpen={open} onClose={handleClose}>
      <div className="p0">
        <div className="m-4 flex justify-between">
          <div>{title}</div>
          <button onClick={handleClose}>
            <IconClose className="h-5 w-5 text-brand-dark-100/40 dark:text-brand-light-100" />
          </button>
        </div>

        <div className="mt-4 text-sm">
          <ReactPlayer
            url={videoUrl}
            playing={false}
            controls={true}
            key={videoUrl}
            width={'100%'}
          />
        </div>
      </div>
    </Modal>
  );
}
